import AsyncStorage from "@react-native-async-storage/async-storage";
import { reverse, sortBy } from "lodash";
import useOrderTotal from "../../hooks/useOrderTotal";
import {
  IOrderContextState,
  IOrderGroup,
  OrderContextActions,
} from "../../interfaces/order";

function minMax(orderGroups: IOrderGroup[]): IOrderGroup[] {
  return orderGroups
    .filter((orderGroup) => ["pending"].includes(orderGroup.tag))
    .reduce((result: IOrderGroup[], orderGroup: IOrderGroup) => {
      result[0] =
        result[0] === undefined || orderGroup?.modified < result[0]?.modified
          ? orderGroup
          : result[0];
      result[1] =
        result[1] === undefined || orderGroup?.modified > result[1]?.modified
          ? orderGroup
          : result[1];
      return result;
    }, []);
}

const Reducer = (state: IOrderContextState, action: OrderContextActions) => {
  switch (action.type) {
    case "SET_ORDER_GROUP":
      let order_groups = reverse(
        sortBy(
          action.payload.filter(
            (order_group) =>
              !["draft", "cancelled", "deleted"].includes(order_group.tag) &&
              useOrderTotal(order_group, false)?.total > 0
          ),
          "modified"
        )
      );

      return {
        ...state,
        order_group: order_groups,
        order_group_pending: order_groups.filter((item) =>
          ["pending"].includes(item.tag)
        ),
        order_group_cancelled: order_groups.filter((item) =>
          ["cancelled", "deleted"].includes(item.tag)
        ),
        order_group_completed: order_groups.filter((item) =>
          ["completed", "delivered"].includes(item.tag)
        ),
        latest_order: minMax(order_groups)[1],
      };
    case "CLEAR_ALL":
      AsyncStorage.removeItem("buyerOrderGroup");

      return {
        ...state,
        order_group: [],
        order_group_pending: [],
        order_group_cancelled: [],
        order_group_completed: [],
      };
    default:
      return state;
  }
};

export default Reducer;
